import { ServiceBase } from "@app/shared";

import { SortDirections } from "@app/shared/waffles";

import { AddRoleGroupModel, RoleGroupModel, RoleGroupListModel, UpdateRoleGroupModel } from "./roleGroup";
import { MinimalUser } from "../user-administration/userModel";
import { querystringify } from "@app/shared/utility";

export default class RoleGroupService extends ServiceBase {

  private authenticationApiEndpoint = `${this.authenticationEndpoint}/api`;

  public async getAllRoleGroups(activeOnly: boolean, includeUsers: boolean, includeEditUsers: boolean, includeRoles: boolean, skip: number, take: number, sortDirection: SortDirections = SortDirections.None, sortedColumn?: string, roleGroupNameFilter?: string, clientNameFilter?: string, roleFilter: number[] = []): Promise<RoleGroupListModel> {
    const query = {
      activeOnly,
      clientNameFilter,
      includeEditUsers,
      includeRoles,
      includeUsers,
      roleFilter,
      roleGroupNameFilter,
      skip,
      sortDirection,
      sortedColumn,
      take,
    };

    return await this.makeGet<RoleGroupListModel>(`/role-groups?${querystringify(query)}`, null, this.authenticationApiEndpoint);
  }

  public async getRoleGroupsByClientId(clientId: number, activeOnly: boolean, includeUsers: boolean, includeEditUsers: boolean, includeRoles: boolean, skip: number, take: number, sortDirection: SortDirections = SortDirections.None, sortedColumn?: string, roleGroupNameFilter?: string, clientNameFilter?: string, roleFilter: number[] = []): Promise<RoleGroupListModel> {
    const query = {
      activeOnly,
      clientNameFilter,
      includeEditUsers,
      includeRoles,
      includeUsers,
      roleFilter,
      roleGroupNameFilter,
      skip,
      sortDirection,
      sortedColumn,
      take,
    };

    return await this.makeGet<RoleGroupListModel>(`/role-groups/clients/${clientId}?${querystringify(query)}`, null, this.authenticationApiEndpoint);
  }

  public async addRoleGroup(model: AddRoleGroupModel): Promise<RoleGroupModel> {
    return await this.makePost<RoleGroupModel>(`/role-groups`, model, this.authenticationApiEndpoint);
  }

  public async updateRoleGroup(roleGroupId: number, model: UpdateRoleGroupModel): Promise<RoleGroupModel> {
    return await this.makePut<RoleGroupModel>(`/role-groups/${roleGroupId}`, model, this.authenticationApiEndpoint);
  }

  public async activateRoleGroup(roleGroupId: number, isActive: boolean): Promise<void> {
    const query = {
      isActive,
    };

    return await this.makePatch<void>(`/role-groups/${roleGroupId}/activate?${querystringify(query)}`, null, false, this.authenticationApiEndpoint);
  }

  public async deleteRoleGroupById(roleGroupId: number): Promise<void> {
    return await this.makeDelete<void>(`/role-groups/${roleGroupId}`, null, this.authenticationApiEndpoint);
  }

  public async roleGroupNameExists(name: string, clientId: number, roleGroupId?: number): Promise<boolean> {
    const query = {
      clientId,
      roleGroupId
    };

    return await this.makeGet<boolean>(`/role-groups/exists/${name}?${querystringify(query)}`, null, this.authenticationApiEndpoint);
  }

  public async getRoleGroupsByUserId(userId: number, activeOnly: boolean, includeRoles: boolean): Promise<RoleGroupModel[]> {
    const query = {
      activeOnly,
      includeRoles
    };

    return await this.makeGet<RoleGroupModel[]>(`/role-groups/users/${userId}?${querystringify(query)}`, null, this.authenticationApiEndpoint);
  }

  public async getUsersAuthorizedForEdit(clientId: number): Promise<MinimalUser[]> {
    return await this.makeGet<MinimalUser[]>(`/role-groups/clients/${clientId}/authorized-users`, null, this.authenticationApiEndpoint);
  }
}
